import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Button } from "reactstrap";
import Sidebar from "./Sidebar";
import WelcomeDashboard from "./WelcomeDashboard";
import DataPendaftaranCendekia from "../Data/DataPendaftaranCendekia";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Dashboard.css";

const Dashboard = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(localStorage.getItem("activeTab") || "welcome"); // Ambil dari localStorage
  const [sidebarExpanded, setSidebarExpanded] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem("token");

      if (!token) {
        console.warn("Token tidak ditemukan, mengalihkan ke login...");
        navigate("/admin/login");
        return;
      }

      try {
        const response = await fetch("https://app.rlagency.id/api_admin/validate-token.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ token })
        });

        const data = await response.json();
        console.log("Validasi Token Response:", data);

        if (!response.ok || !data.success) {
          console.error("Token tidak valid:", data.message);
          localStorage.removeItem("token");
          navigate("/admin/login");
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        console.error("Kesalahan saat validasi token:", error);
        localStorage.removeItem("token");
        navigate("/admin/login");
      }
    };

    checkAuth();
  }, [navigate]);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      localStorage.setItem("activeTab", tab); // Simpan ke localStorage
    }
  };

  const toggleSidebar = () => {
    setSidebarExpanded(!sidebarExpanded);
  };

  if (isLoading) {
    return <p>Loading...</p>;
  }

  return (
    <Container fluid>
      <Row className="g-0">
        <Button
          color="primary"
          className="sidebar-toggle d-md-none"
          onClick={toggleSidebar}
        >
          {sidebarExpanded ? "Sembunyikan Sidebar" : "Tampilkan Sidebar"}
        </Button>

        <div className={`sidebar-container ${sidebarExpanded ? "expanded" : ""}`}>
          <Sidebar toggleTab={toggleTab} activeTab={activeTab} />
        </div>

        <div className={`content-container ${sidebarExpanded ? "with-sidebar" : "no-sidebar"}`}>
          <div className="content-panel">
            {activeTab === "welcome" && <WelcomeDashboard />}
            {activeTab === "data" && <DataPendaftaranCendekia />}
          </div>
        </div>
      </Row>
    </Container>
  );
};

export default Dashboard;
